<template>
  <b-card no-body
          v-draggable
          ref="autoscout_subcard"
          :id="isLegacyMode ? 'autoscout-subcard' : 'autoscout-subcard-free'">
    <!-- Header -->
    <b-card-header  v-if="isLegacyMode"
                    style="color: lightgrey; height: 25px; cursor: move"
                    class="pl-2 pb-0 pt-0"
                    header-tag="div"
                    header-bg-variant="dark">
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          Autoscout24
          <span v-if="isCompetitor">-
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}</span
          >
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon  class="mx-1 clickable"
                              :icon="['far', 'times']"
                              @click="close()" />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <div  v-if="isLoading" 
          :class="{ spinner: isLoading }" 
          style="height:200px">
    </div>

    <b-card-text  v-else-if="AutoscoutData != null" 
                  class="pl-3 pr-3" 
                  style="overflow: auto">
      <!-- Top menu -->
      <b-row>
        <b-col cols="11" class="subcard-title mb-3">
          {{ headLine || AutoscoutData.Name }}
        </b-col>
      </b-row>
      
      <b-button-group>
        <CompetititorDropbox
          v-if="AutoscoutData.Competitors && AutoscoutData.Competitors.length > 0"
          :competitorList="AutoscoutData.Competitors"
          @openCompetitor="openCompetitor"
        />
        <b-button target="_blank" rel="noopener" v-if="autoscoutURL || (AutoscoutData.Autoscout && AutoscoutData.Autoscout.AutoscoutURL)" :href="autoscoutURL || AutoscoutData.Autoscout.AutoscoutURL">
          <font-awesome-icon
            style="height: 15px; width: 15px"
            :icon="['far', 'external-link']"
          />
          {{ $t("Webportal.CX.Dashboard.Exploration.Autoscout.AutoscoutLink")}}
        </b-button>
      </b-button-group>

      <template v-if="!isCompetitor">
        <ScoresChart :Scores="AutoscoutData.OverallScores" :Width="700"/>
        <hr>

        <table class="table mb-0 app-ctrl" v-if="AutoscoutData.Ratings">
          <tr >
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.History") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </tr>
          <RatingTableRow
            class="app-ctrl"
            v-for="item in AutoscoutData.Ratings"
            :key="item.title"
            :Title="item.RatingTypeName"
            :translationPrefix="'Webportal.CX.Dashboard.Exploration.Autoscout.'"
            :Ratings="item.RatingTypeResults" />
        </table>

        <hr />
      </template>
      <template v-else>
        <div class="overallscore mb-3" v-if="AutoscoutData.Autoscout && AutoscoutData.Autoscout.Ratings">
          <span class="label">{{ $t("Webportal.CX.Exploration.OverallScore")}}</span>
          <span class="value">{{AutoscoutData.Autoscout.Ratings.find(r => r.Name == 'OverallScore').Value}} <b-icon icon="star-fill" class="text-warning"></b-icon></span>
        </div>

        <table class="table" v-if="AutoscoutData.Autoscout && AutoscoutData.Autoscout.Ratings">
          <thead>
            <tr>
              <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
              <th class="border-top-0" colspan="2">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
            </tr>
          </thead>
          <CompetitorRatingTableRow v-for="(rating) in AutoscoutData.Autoscout.Ratings.filter(r => r.Name != 'OverallScore')" 
            :rating="rating"
            :key="rating.Name"
            :translationPrefix="'Webportal.CX.Dashboard.Exploration.Autoscout.'"
            />
        </table>
        <hr>
      </template>
      
      <!-- Reviews -->
      <div v-if="Reviews.length <= 0" class="pb-3">
        {{ $t("Webportal.CX.Dashboard.Exploration.NoReviews") }}
      </div>

      <div v-else>
        <p style="color: grey; font-size: 0.9rem">
          {{ ReviewCount }}
          {{ $t("Webportal.CX.Dashboard.Exploration.Autoscout.Reviews") }}
        </p>
        <p>{{ $t("Webportal.CX.Dashboard.Exploration.LatestReviews") }}:</p>
        <div class="pb-4" style="overflow: auto; height: 50%">
          <Accordion
            v-for="(review, index) in Reviews"
            :key="index"
            :toggleCols="1"
            class="mb-2"
          >
            <!-- Headline -->
            <b-row slot="short" class="mb-2 pr-0 mr-0" style="width: 110%">
              <b-row
                class="m-0 mb-3 p-0"
                style="
                  font-size: 0.9rem;
                  font-weight: 600;
                  line-height: 1;
                  width: 100%;
                "
              >
                <b-col cols="3">
                  <span>{{ new Date(review.Time).toLocaleDateString() }}</span>
                </b-col>
                <b-col cols="8">
                  <span>
                    {{ review.AuthorName }}
                  </span>
                </b-col>
              </b-row>

              <!-- First row -->
              <b-row style="width: 110%">
                <!-- Review rating: Overall Score -->
                <b-col cols="3" v-if="review.OverallScore">
                  <b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.OverallScore"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-left"
                  v-if="review.OverallScore"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.OverallScore"
                    )
                  }}
                </b-col>

                <!-- Review rating: Overall Impression -->
                <b-col
                  cols="3"
                  class="review-right-star-col"
                  v-if="review.OverallImpression"
                >
                  <b-form-rating
                    variant="warning"
                    class="app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.OverallImpression"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-right"
                  v-if="review.OverallImpression"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.OverallImpression"
                    )
                  }}
                </b-col>
              </b-row>

              <!-- Second row -->
              <b-row style="width: 110%">
                <!-- Review rating: Accessibility -->
                <b-col cols="3" v-if="review.Accessibility">
                  <b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Accessibility"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-left"
                  v-if="review.Accessibility"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.Accessibility"
                    )
                  }}
                </b-col>

                <!-- Review rating: Reliability -->
                <b-col
                  cols="3"
                  class="review-right-star-col"
                  v-if="review.Reliability"
                >
                  <b-form-rating
                    class="app-ctrl"
                    variant="warning"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Reliability"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-right"
                  v-if="review.Reliability"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.Reliability"
                    )
                  }}
                </b-col>
              </b-row>

              <!-- Third row -->
              <b-row style="width: 120%">
                <!-- Review rating: Offer Description -->
                <b-col cols="3" v-if="review.OfferDescription">
                  <b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.OfferDescription"
                  />
                </b-col>
                <b-col
                  cols="3"
                  class="review-caption-left"
                  v-if="review.OfferDescription"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.OfferDescription"
                    )
                  }}
                </b-col>

                <!-- Review rating: Buying process (OPTIONAL) -->
                <b-col
                  v-if="review.BuyingProcess"
                  cols="3"
                  class="review-right-star-col"
                >
                  <b-form-rating
                    variant="warning"
                    class="app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.BuyingProcess"
                  />
                </b-col>
                <b-col
                  v-if="review.BuyingProcess"
                  cols="3"
                  class="review-caption-right"
                >
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Autoscout.BuyingProcess"
                    )
                  }}
                </b-col>
              </b-row>
            </b-row>

            <!-- Accordion -->
            <template slot="long">
              <!-- Review text message -->
              <p class="mb-2" v-if="review.ReviewText">
                {{ review.ReviewText }}
              </p>

              <!-- Reply of retailer -->
              <div v-if="review.ReplyText">
                <hr v-if="review.ReviewText" />
                <h6>
                  <span v-if="review.ReplyTime">{{ new Date(review.ReplyTime).toLocaleDateString() }} - </span>Reply of
                  retailer:
                </h6>
                <p class="mb-2">
                  {{ review.ReplyText }}
                </p>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Accordion from "../Accordion";
import RatingDistribution from "./RatingDistribution";
import DashboardService from "@/services/DashboardService";
import RatingTableRow from "@/components/CX/ExplorationCard/RatingTableRow";
import TrendIcon from "@/components/Shared/TrendIcon";
import ScoresChart from "@/components/CX/ExplorationCard/ScoresChart";
import CompetititorDropbox from "./CompetitorDropbox";
import CompetitorRatingTableRow from "@/components/CX/CompetitorRatingTableRow";

export default {
  name: "AutoscoutPopup",
  components: {
    Accordion,
    CompetititorDropbox,
    CompetitorRatingTableRow,
    RatingDistribution,
    RatingTableRow,
    ScoresChart,
    TrendIcon,
  },

  props: {
    autoscoutData:            { type: Object, default: () => {} },
    autoscoutURL:             { type: String },
    headLine:                 { type: String },
    isCompetitor:             { type: Boolean, default: false },
    isLegacyMode:             { type: Boolean, default: true },
    competitorId:             { type: Number }
  },

  data() {
    return {
      AutoscoutData: null,
      AutoscoutLastRating: {},
      isLoading: true
    };
  },
  watch: {
    AutoscoutData: {
      immediate: true,
      handler(val, oldVal) {
        // TODO: "temp. workaround"
        // For design purposes, we currently need the last element separately
        if (this.Ratings.length >= 5 && _.isEmpty(this.AutoscoutLastRating)) {
          // Only if 5 elements (should be the case!)
          this.AutoscoutLastRating = this.Ratings.pop();
        }
      }
    }
  },
  computed: {
    _() {
      return _;
    },
    ReviewCount: function() {
      return (
        this.RatingsByName?.ReviewCount?.Value || this.Reviews?.length || 0
      );
    },
    Reviews: function() {
      return (
        this.AutoscoutData?.Reviews ||
        this.AutoscoutData?.Autoscout?.Reviews ||
        []
      );
    },
    Ratings: function() {
      return (
        this.AutoscoutData?.Ratings ||
        this.AutoscoutData?.Autoscout?.Ratings ||
        []
      );
    },
    RatingsByName: function() {
      return (
        this.AutoscoutData?.RatingsByName ||
        this.AutoscoutData?.Autoscout?.RatingsByName ||
        {}
      );
    },
    OverallScore: function() {
      return (
        this.AutoscoutData?.Threshold?.Value ||
        this.RatingsByName?.OverallScore?.Value ||
        0
      );
    },
    Recommendation: function() {
      return this.RatingsByName?.Recommendation?.Value || 0;
    }
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function() {
    if (this.isCompetitor) {
      this.getCompetitor(this.competitorId).then(response => {
        this.AutoscoutData = response.data;
      }).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.AutoscoutData = { ...this.autoscoutData };
      // use setTimeout() to await next event cycle/finished building
      window.setTimeout(() => {this.isLoading = false}, 0);
    }
  },
  methods: {
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },
    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { autoscout: true });
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  }
};
</script>

<style scoped>
.autoscout-rating {
  /* width: 88%; */
  margin-left: 5px;
  margin-right: 5px;
  color: grey;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(92, 92, 92, 0.2);
}
.review-caption-left {
  margin-left: -5px;
  padding: 0;
}
.review-caption-right {
  margin-left: -10px;
  padding: 0;
}
.review-right-star-col {
  margin: 0 0px 0 -5px;
  padding: 0 15px 0 0;
}
.subcard-title {
  font-size: 1.5rem;
}
#autoscout-subcard {
  position: fixed !important;
}
td span {
  text-align: right;
  display: inline-block;
  min-width: 4rem;
}
</style>
